import { useNavigate } from "react-router-dom"
import { PaymentTableRowType } from "../../types"
import dayjs from "dayjs"
import isBetween from "dayjs/plugin/isBetween"
import { ReactComponent as EscalationIcon } from "./../../../../assets/EscalationRequiredICON.svg"
import { ReactComponent as INFO } from "./../../../../assets/InfoICON.svg"
import { ReactComponent as CHECK } from "./../../../../assets/ApprovaICON.svg"
import { Tag } from "antd"
import BaseTableRow from "../../../../components/layout/BaseTableRow"
import BasePopover from "../../../../components/elements/BasePopover"
import { P } from "../../../../auth/permissions"
import { Authorized } from "../../../../components/authentication/Authorized"
dayjs.extend(isBetween)

export default function PaymentTableRow(props: PaymentTableRowType) {
    const navigate = useNavigate()
    const target = dayjs(props.delivery)
    const today = dayjs()

    return (
        <BaseTableRow onClick={() => navigate("/buchhaltung/rechnung/" + props.id)} classProps={props.archived ? "opacity-40 bg-gray-100" : ""}>
            <td onClick={() => navigate("/buchhaltung/rechnung/" + props.id)} className="table-cell">
                <p className="line-clamp-1  text-center">{dayjs(props.delivery).format("DD.MM.YYYY")}</p>
            </td>
            <td onClick={() => navigate("/buchhaltung/rechnung/" + props.id)} className="hidden xl:table-cell">
                <p className="line-clamp-1  text-center">{dayjs(props.invoice).format("DD.MM.YYYY")}</p>
            </td>
            <td
                onClick={(event) => {
                    event.stopPropagation()
                    props.openPauseReminderModal()
                }}
                className={`hidden 2xl:table-cell z-10 hover:underline  ${
                    dayjs(props.nextReminder).isBetween(today, dayjs().add(5, "day"), "day", "[]") && props.status !== "settled" && props.status !== "canceled" ? "font-semibold text-error" : ""
                }`}>
                <p className={`line-clamp-1 text-center`}>
                    {dayjs(props.nextReminder).format("DD.MM.YYYY")} {props.pausedReminder && props.pausedReminder > 0 ? `(+${props.pausedReminder}d)` : ""}
                </p>
            </td>
            <td onClick={() => navigate("/buchhaltung/rechnung/" + props.id)}>
                <p title={props.title} className="line-clamp-1  text-center w-full min-w-[10rem]">
                    Rechnung {props.title}
                </p>
            </td>
            <td onClick={() => navigate("/buchhaltung/rechnung/" + props.id)}>
                <p className="line-clamp-1 w-full min-w-[4rem] text-center">{props.netto?.toFixed(2)?.toString()?.replace(".", ",")} €</p>
            </td>
            <td className="hidden 2xl:table-cell" onClick={() => navigate("/buchhaltung/rechnung/" + props.id)}>
                <p className="line-clamp-1 text-center">{props.brutto?.toFixed(2)?.toString()?.replace(".", ",")} €</p>
            </td>
            <td onClick={() => navigate("/buchhaltung/rechnung/" + props.id)} className="hidden md:table-cell">
                <p title={props.customer} className="line-clamp-1  text-center">
                    {props.customer}
                </p>
            </td>
            <td onClick={() => navigate("/buchhaltung/rechnung/" + props.id)} className="hidden md:table-cell">
                <p className={`line-clamp-1 text-center`}>
                    {props.escalationRequired ? (
                        <Tag color="red-inverse" className="w-36 text-center">
                            Mahnungen Überfällig
                        </Tag>
                    ) : props.escalationSolvedDate ? (
                        <Tag className="w-36 text-center bg-gray-100 text-gray-700 border-gray-300">
                            Manuell geklärt {dayjs(props.escalationSolvedDate).format("DD.MM.YYYY")}
                        </Tag>
                    ) : props.status === "settled" ? (
                        <Tag color="green-inverse" className="w-24 text-center">
                            Beglichen
                        </Tag>
                    ) : props.status === "canceled" ? (
                        <Tag className="w-24 text-center">Storniert</Tag>
                    ) : props.status === "unpaid" && target < today ? (
                        <Tag color="red" className="w-32 text-center">
                            {`${today.diff(target, "day") + 1} Tage überfällig`}
                        </Tag>
                    ) : (
                        <Tag color="gold" className="w-24 text-center">
                            Ausstehend
                        </Tag>
                    )}
                </p>
            </td>
            <td
                onClick={(event) => {
                    event.stopPropagation()
                    props.modalOpen()
                }}>
                <INFO className="w-6 h-6 z-10 " />
            </td>
            <Authorized allOf={[P.buchhaltung_zahlungen_read_write]}>
                <td onClick={(event) => event.stopPropagation()}>
                    {props.status !== "settled" && props.status !== "canceled" && (
                        <p title="Als bezahlt markieren">
                            <BasePopover placement="bottomLeft" label="Zahlungsaufforderung beglichen?" text="Die Zahlungsaufforderung wird als beglichen markiert." okButtonClick={props.markAsPaid}>
                                <CHECK className="w-6 h-6 z-10 " />
                            </BasePopover>
                        </p>
                    )}
                </td>
            </Authorized>
            <Authorized allOf={[P.buchhaltung_zahlungen_read_write]}>
                {props.escalationRequired && !props.escalationSolvedDate ? (
                    <td
                        onClick={(event) => {
                            event.stopPropagation()
                            props.openSolveEscalationModal()
                        }}>
                        <EscalationIcon className="w-6 h-6 z-10 " />
                    </td>
                ) : (
                    <td />
                )}
            </Authorized>
        </BaseTableRow>
    )
}
